import $ from 'jquery'
export default class VimeoVideoPlayer {
  constructor({
    containerId,
    videoId,
    height = 600,
    width = 600,
    playButton,
    stopButton,
    customControls = false,
    title = true,
    byline = false,
    portrait = true
  }) {
    const vimeoOptions = {
      id: videoId,
      height,
      width,
      controls: !customControls,
      title,
      byline,
      portrait
    }
    this.playButton = playButton
    this.stopButton = stopButton
    this.player = new window.Vimeo.Player(containerId, vimeoOptions)
    this.$controlButtonWrapper = $(`.vimeo__control-buttons`)
    this.enableCustomControls(customControls)
  }
  playVideo() {
    this.player.play()
    this.showControlButton(`pause`)
  }
  pauseVideo() {
    this.player.pause()
    this.showControlButton(`play`)
  }
  showControlButton(type) {
    if (type === `play`) {
      $(`#${this.containerId}`).removeClass(`is-playing`)
      $(this.playButton).removeClass(`fade`)
      $(this.stopButton).addClass(`fade`)
    } else if (type === `pause`) {
      $(`#${this.containerId}`).addClass(`is-playing`)
      $(this.playButton).addClass(`fade`)
      $(this.stopButton).removeClass(`fade`)
    }
  }
  enableCustomControls(enableCustomControls) {
    if (enableCustomControls) {
      this.$controlButtonWrapper.show()
    } else {
      this.$controlButtonWrapper.hide()
    }
  }
}
